import { DIY_DOC_TYPES } from "../post-inspection-diy/constant";
import  {aadharVerifyClicked, panVerifyClicked} from "./tracking";

export const GA_DOCUMENT_TYPES = {
    [DIY_DOC_TYPES.AADHAR_CARD]: aadharVerifyClicked,
    [DIY_DOC_TYPES.PAN_CARD]: panVerifyClicked
};
